module.exports = __webpack_public_path__ + "bj.svg?22430301448ceea1471d979ca319be92";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/1x1/bj.svg
// module id = 1259
// module chunks = 0